import React from 'react';
import { format } from 'date-fns';
import { 
  HiOutlineClock, 
  HiOutlineExclamationTriangle, 
  HiOutlineCalendarDays,
  HiOutlineArrowRight
} from 'react-icons/hi2';
import styles from './FollowUpPanel.module.css';

const FollowUpPanel = ({ followUps, onEdit }) => {
  const today = new Date().toDateString();

  const todayFollowUps = followUps.filter(app => 
    app.follow_up_date && new Date(app.follow_up_date).toDateString() === today
  );

  const overdueFollowUps = followUps.filter(app => 
    app.follow_up_date && new Date(app.follow_up_date) < new Date() && 
    new Date(app.follow_up_date).toDateString() !== today
  );

  const upcomingFollowUps = followUps.filter(app => 
    app.follow_up_date && new Date(app.follow_up_date) > new Date()
  ).slice(0, 5);

  const formatDate = (dateString) => {
    return format(new Date(dateString), 'MMM dd');
  };

  const FollowUpItem = ({ app, type }) => {
    const getIcon = () => {
      switch (type) {
        case 'overdue':
          return <HiOutlineExclamationTriangle className={styles.itemIcon} />;
        case 'today':
          return <HiOutlineClock className={styles.itemIcon} />;
        case 'upcoming':
          return <HiOutlineCalendarDays className={styles.itemIcon} />;
        default:
          return <HiOutlineCalendarDays className={styles.itemIcon} />;
      }
    };

    return (
      <div 
        className={`${styles.followUpItem} ${styles[type]}`}
        onClick={() => onEdit(app)}
      >
        <div className={styles.itemContent}>
          <div className={styles.itemHeader}>
            {getIcon()}
            <div className={styles.itemInfo}>
              <span className={styles.company}>{app.company_name}</span>
              <span className={styles.role}>{app.role}</span>
            </div>
            <div className={styles.itemDate}>
              <span className={styles.date}>{formatDate(app.follow_up_date)}</span>
            </div>
          </div>
        </div>
        <HiOutlineArrowRight className={styles.arrowIcon} />
      </div>
    );
  };

  return (
    <div className={styles.followUpPanel}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <HiOutlineClock className={styles.titleIcon} />
          <h3 className={styles.title}>Follow-ups</h3>
        </div>
      </div>

      <div className={styles.sections}>
        {overdueFollowUps.length > 0 && (
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <h4 className={styles.sectionTitle}>
                Overdue
                <span className={styles.sectionCount}>{overdueFollowUps.length}</span>
              </h4>
            </div>
            <div className={styles.followUpList}>
              {overdueFollowUps.map(app => (
                <FollowUpItem key={app.id} app={app} type="overdue" />
              ))}
            </div>
          </div>
        )}

        {todayFollowUps.length > 0 && (
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <h4 className={styles.sectionTitle}>
                Today
                <span className={styles.sectionCount}>{todayFollowUps.length}</span>
              </h4>
            </div>
            <div className={styles.followUpList}>
              {todayFollowUps.map(app => (
                <FollowUpItem key={app.id} app={app} type="today" />
              ))}
            </div>
          </div>
        )}

        {upcomingFollowUps.length > 0 && (
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <h4 className={styles.sectionTitle}>
                Upcoming
              </h4>
            </div>
            <div className={styles.followUpList}>
              {upcomingFollowUps.map(app => (
                <FollowUpItem key={app.id} app={app} type="upcoming" />
              ))}
            </div>
          </div>
        )}

        {followUps.length === 0 && (
          <div className={styles.empty}>
            <HiOutlineCalendarDays className={styles.emptyIcon} />
            <p>No follow-ups scheduled</p>
            <span className={styles.emptyHint}>
              Set follow-up dates to track your applications
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FollowUpPanel;